import axios from "axios";

export const GET_POPUP_EDIT_ROW_URL = "/invoiceOrders/getInvoiceOrder?invoiceOrderID=";
export const EDIT_INVOICE_ORDER = "/invoiceOrders/editInvoiceOrder";

export function findPopupEditRowData(invoiceOrderID) {
  return axios.get(`${GET_POPUP_EDIT_ROW_URL}${invoiceOrderID}`, invoiceOrderID);
}

export function editInvoiceOrder(values) {
  return axios.post(EDIT_INVOICE_ORDER, values);
}
